import type { NotificationType } from './NotificationsMenu.types';

import { isCommentLike } from './isCommentLike';

export const shouldGenerateActionLink = ({
  type,
  data,
}: {
  type?: NotificationType;
  data?: {
    actionType?: string;
  };
}) =>
  isCommentLike({ type, data }) ||
  (type &&
    [
      'changeCard',
      'createdCard',
      'addAttachmentToCard',
      'addedToCard',
      'removedFromCard',
      'cardDueSoon',
    ].includes(type));
